module.exports = __webpack_public_path__ + "a78e9efe0925239e3ad85b542a569ede.svg";